import { render, staticRenderFns } from "./category-tag.vue?vue&type=template&id=e4387c46&scoped=true"
import script from "./category-tag.vue?vue&type=script&lang=js"
export * from "./category-tag.vue?vue&type=script&lang=js"
import style0 from "./category-tag.vue?vue&type=style&index=0&id=e4387c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4387c46",
  null
  
)

export default component.exports